import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Subject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { componentName } from '../shared/constants/commonenums';
import { urlConfig } from '../shared/constants/url-config';
import { FloorPlanImagesDto } from '../shared/dynamicform/models/common-models';
import { CustomGuestFieldsModel, ReservationDTO } from '../shared/Models/PartyModels';
import { SlotLockResultDTO } from '../shared/Models/SlotLockModels';
import { DataRetentionPolicy, operationType, WidgetSettingsDTO } from '../shared/Models/WidgetSettingsModels';
import { HttpService } from '../shared/services/http.service';



var intervalID;
@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  curentComponent: any;
  //@Output() closeEvent = new EventEmitter();



  nextButton = new Subject<any>();
  previousButton = new Subject<any>();

  restaurantWidgetSettings$ = new BehaviorSubject<WidgetSettingsDTO>(null);
  editPartyData$ = new BehaviorSubject<ReservationDTO>(null);
  showTimer = false;
  timerSubscription: Subscription = new Subscription();
  minutes: number;
  seconds: number;
  totalTime: number;
  lockResult: SlotLockResultDTO;
  customGuestFields: CustomGuestFieldsModel;
  showMessage: boolean;
  message: string;
  language: Number;
  editPartyData: any;
  reservationToken: string;
  specialMealIdFromURL : number;
  operation: operationType = operationType.create;
  
  dataRetentionPolicy$ = new BehaviorSubject<DataRetentionPolicy>(null);
;
  countriesList: any;
  globalSeatingAreaId: number;
  restaurantWidgetName: string;
  fromclient = false;
  byPassValidation = false;
  public restaurantImages: BehaviorSubject<FloorPlanImagesDto> = new BehaviorSubject<FloorPlanImagesDto>(null);
  isMobileBrowser = false;
  refundData: any;
  OperationCurrency:string;
  isCommunalTableSelected: boolean;
  constructor(private httpService: HttpService) {
    this.findUserAgent();
  }

  // getSpecialMeal() {
  //  this.httpService.get(urlConfig.specialMealsUrl + 'Blue-Beach-Cabanas-xxx').subscribe(response =>
  // {
  //     return response.Payload;
  // }
  //   );
  // }
  findUserAgent() {
    const objAgent = navigator.userAgent;
    if (objAgent.indexOf("Mobile") !== -1) {
      this.isMobileBrowser = true;
    }
  }

  getRestaurantImages(restaurantId) {
    this.httpService.get(urlConfig.getImages + restaurantId).subscribe((images) => {
      const allAvailableImages = images.Payload as FloorPlanImagesDto;
      this.restaurantImages.next(allAvailableImages);
    });
  }

  getWidgetSettingsByRestaurantName(restaurantName: string, languageId: number = 1) {
    return this.httpService.get(`${urlConfig.getWidgetSettings}?restaurantName=${restaurantName}&languageId=${sessionStorage.getItem('languageId')}`).pipe(
      map((data: any) => data.Payload as WidgetSettingsDTO));
  }

  getWidgetSettingsByRestaurantId(restaurantId: Number) {
    return this.httpService.get(`${urlConfig.getWidgetSettings}?restaurantId=${restaurantId}&languageId=${sessionStorage.getItem('languageId')}`).pipe(
      map((data: any) => data.Payload as WidgetSettingsDTO));
  }

  GetCustomFields(restaurantId: Number) {
    return this.httpService.get(`${urlConfig.getCustomGuestFields}?restaurantId=${restaurantId}`).pipe(map((data: any) => data.Payload as CustomGuestFieldsModel));
  }

  getByToken(token: string) {
    return this.httpService.get(`${urlConfig.getByToken}?token=${token}`).pipe(map((data: any) => data.Payload as ReservationDTO));
  }

  getBannerImage(restaurantId: Number) {
    return this.httpService.get(`${urlConfig.bannerImageUrl}?Id=${restaurantId}`);
  }

  getBackgroundImage(restaurantId: Number) {
    return this.httpService.get(`${urlConfig.backgroundImageUrl}?restaurantId=${restaurantId}`);
  }

  GetRestaurantPolicy(restaurantId: Number) {
    return this.httpService.get(`${urlConfig.restaurantPolicy}?restaurantId=${restaurantId}`).pipe(map((data: any) => data.Payload as DataRetentionPolicy));
  }


  GetCountries() {
    return this.httpService.get(`${urlConfig.getCountries}`).pipe(map((data: any) => data.Payload));
  }



  runTimer(timerValue) {
    this.totalTime = timerValue;
    this.minutes = Math.floor(this.totalTime / 60);
    this.seconds = Number(this.totalTime % 60);
    this.timerSubscription = interval(1000 * 1).subscribe(() => {
      this.totalTime = this.totalTime - 1;
      this.minutes = Math.floor(this.totalTime / 60);
      this.seconds = Number(this.totalTime % 60);
      if (this.totalTime == 0) {
        this.UnSubscribeTimerAndRedirectToHome();
      }
    })
  }

  UnSubscribeTimerAndRedirectToHome() {
    this.offTimer();
    this.editPartyData = '';
    this.nextButton.next(componentName.reservationDetails);
    //Discard all form Details;
  }

  offTimer() {
    this.showTimer = false;
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  getDateFormats(){
    let myFormats = {
      display: {
       dateInput: this.restaurantWidgetSettings$.value.DateFormat,      
        monthYearLabel: this.restaurantWidgetSettings$.value.DateFormat,
        dateA11yLabel: this.restaurantWidgetSettings$.value.DateFormat,
        monthYearA11yLabel: this.restaurantWidgetSettings$.value.DateFormat,
      }
    };
    return myFormats;
  }
}


